export const isTouchEvent = (evt: any): evt is TouchEvent => {
  return window.TouchEvent && evt instanceof TouchEvent;
};
